import { AutogenModelMarketPlan, AutogenRowMarketPlan } from "./autogen/AutogenModelMarketPlan";

export class ModelMarketPlan extends AutogenModelMarketPlan<RowMarketPlan> {
	constructor() {
		super(RowMarketPlan);
	}
}

export class RowMarketPlan extends AutogenRowMarketPlan {
}